import { ContainerOptionsLabel } from "./styles";

interface IOptionsLabelSelect {
  name: string;
  flag: string;
  ddi: string;
}

export const OptionsLabel = (optionsData: IOptionsLabelSelect) => {
  return (
    <ContainerOptionsLabel className="optionsLabel">
      <span>{optionsData.flag}</span>
      <p>{optionsData?.name}</p>
    </ContainerOptionsLabel>
  );
};
